import React, { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LoanFormType } from 'views/orders/loans/types';

import { OptionalChoiceForm } from '../optional-choice-form';

type Props = {
  control: Control<LoanFormType, object>;
  isDataLoading: boolean;
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const LiabilityForm: FC<Props> = ({ control, isDataLoading, onSave }) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="unpaid_liability"
      render={({ field }) => (
        <OptionalChoiceForm
          title={t('disclosure:liability-after-foreclosure')}
          description={t('disclosure:if-you-lender')}
          value={field.value}
          options={[
            {
              label: t('disclosure:protects-from-unpaid-balance-liability'),
              disabled: isDataLoading,
              value: true
            },
            {
              label: t('disclosure:dont-protects-from-unpaid-balance-liability'),
              disabled: isDataLoading,
              value: false
            }
          ]}
          onChange={(value) => field.onChange(value)}
          onSave={() => { onSave(); }}
          onBlur={() => {
            onSave();
          }}
        />
      )}
    />
  );
};
